module.exports = __webpack_public_path__ + "static/media/LabReports@2x.af561ba3.jpg";